import { useMutation, useQueryClient } from '@tanstack/react-query';

import UserStore from 'src/app_deprecated/stores/UserStore';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from '../marketing/get-campaigns';

type Template = {
  HtmlBody: string;
  IsDynamic: boolean;
  JsonBody: string;
  MarketingEmailTemplateId: number;
};

type SaveEmailTemplatePayload = {
  Template: Template & { LspId: number };
};

type SaveEmailTemplateResponse = {
  templateId: number;
};

export function useSaveEmailTemplateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (template: Template) => {
      const userApiData = UserStore.getApiData(template);
      const payloadWithLSP = {
        Template: { ...template, LspId: userApiData.LspId },
      };

      const res = postData<SaveEmailTemplatePayload, SaveEmailTemplateResponse>({
        endpoint: 'api/email-marketing/upsert-template',
        payload: payloadWithLSP,
      });
      return res;
    },
    onSuccess: (data) => {
      void queryClient.invalidateQueries([...marketingCampaignsQueryKey, 'saved-email', data.templateId]);
    },
  });
}
